import { render } from "./CxObject.vue?vue&type=template&id=20cf1db6"
import script from "./CxObject.vue?vue&type=script&lang=js"
export * from "./CxObject.vue?vue&type=script&lang=js"

import "./CxObject.vue?vue&type=style&index=0&id=20cf1db6&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__